import request from '@/utils/request'

export function addDemo (data) {
  return request({
    url: '/addDemo',
    method: 'post',
    data
  })
}
